import { render, staticRenderFns } from "./ConvenioPracticas.vue?vue&type=template&id=33943251&scoped=true&"
import script from "./ConvenioPracticas.vue?vue&type=script&lang=js&"
export * from "./ConvenioPracticas.vue?vue&type=script&lang=js&"
import style0 from "./ConvenioPracticas.vue?vue&type=style&index=0&id=33943251&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33943251",
  null
  
)

export default component.exports